import { LoadOrderTrackingPage } from "@/components/LoadOrderTrackingPage";

const LoadOrderTracking = () => {
  return <LoadOrderTrackingPage />;
};

export default LoadOrderTracking;